<template>
	<div class="student-lesson">
		<div v-if="loading" class="text-center">
			<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
			<span class="sr-only">Loading...</span>
		</div>
		<h2>{{ name }}</h2>

		<!-- <iframe width="560" height="315" src="https://www.youtube.com/embed/-cJaCWm21LE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		
		<iframe width="560" height="315" class="ql-video" frameborder="0" allowfullscreen="true" src="https://www.youtube.com/embed/UUupw_KjWAg?showinfo=0"></iframe> -->

		<div classname="body-wrap" v-html="body"></div>
	</div>
</template>

<script>
export default {
	name: 'lesson',
	data() {
		return {
			loading: true,
			lesson: {},
		}
	},
	computed: {
		body() {
			let lang = this.$i18n.locale() === 'ua' ? 'uk' : this.$i18n.locale()

			// console.log(this.lesson[`body_${lang}`])

			return this.lesson[`body_${lang}`]
		},
		name() {
			let lang = this.$i18n.locale() === 'ua' ? 'uk' : this.$i18n.locale()
			return this.lesson[`name_${lang}`]
		},
	},
	created() {
		this.axios({
			method: 'get',
			url: `lessons/${this.$route.params.id}`,
		})
			.then(response => {
				this.lesson = response.data
				this.loading = false
			})
			.then(() => {
				const videoFrame = document.getElementsByClassName('ql-video')

				videoFrame.forEach(item => {
					item.setAttribute('width', '100%')

					item.style.aspectRatio = '16 / 9'
				})
			})
	},
}
</script>

<style>
.student-lesson img {
	max-width: 100%;
	max-height: 400px;

	margin: auto;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.student-lesson {
	margin: 20px auto 0 9%;
	width: 80%;
	padding: 18px;
	border-radius: 12px;
	border: 2px solid #ddd;
	background-color: #fff;

	text-align: center;

	transform: scale(0.85);
	transform-origin: top left;
}

.body-wrap {
	width: 100%;
}

img {
	max-width: 100%;
}

@media (min-width: 992px) and (max-width: 1199px) {
	h5 {
		font-size: 19px;
	}
}

@media (max-width: 991px) {
	h5 {
		margin-top: 30px;
	}
}
</style>
